import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { MathNode, NODE_TYPE } from './math';
import { FormArray, FormGroup } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { getEditTypes } from '../../../delegatorUtils';
import { swalMini } from '../../../../../../../shared/utils/utils';

@Component({
  selector: 'app-math',
  templateUrl: './math.component.html',
  styleUrls: ['./math.component.scss'],
})
export class MathComponent extends NodeBuilder implements OnInit {

  mathForm: FormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {

  }

  set buildForm(stepData: any) {
    this.mathForm = MathNode.toForm(stepData, this.canEdit);

    if (this.mathForm.get('yes').value === newStepValue) {
      this.mathForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.mathForm.get('no').value === newStepValue) {
      this.mathForm.get('no').setValue('step' + this.getNextStep());
    }
    if (this.mathForm.get('error').value === newStepValue) {
      this.mathForm.get('error').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const nodeData = new MathNode();
    nodeData.addMathData(this.mathForm.getRawValue());
    return nodeData.nodeData;
  }

  get isNodeValid(): boolean {
    this.mathForm.markAllAsTouched();
    return this.mathForm.valid;
  }

  addVariable() {
    const { editFlows } = getEditTypes(this.canEdit);
    const vars = this.mathForm.get('variables') as FormArray;
    vars.push(MathNode.variableTemple('', '', editFlows));
  }

  deleteVariable(index: number) {
    const vars = this.mathForm.get('variables') as FormArray;
    if (vars.length > 1) {
      vars.removeAt(index);
    } else {
      swalMini({ title: 'At least one option needed', type: 'error' });
    }

  }

}
